import { render, staticRenderFns } from "./DeleteShop.vue?vue&type=template&id=6f838582"
import script from "./DeleteShop.vue?vue&type=script&lang=js"
export * from "./DeleteShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports